import React, { useContext, useEffect, useState } from "react";
import { Spin } from "antd";
import { queryProductList } from "@/services/api";
import { GAClickVipBuy } from "@/ga/personCenter";
import "../../index.less";

/**
 * 开通VIP组件
 * @returns
 */
const OpenVip = () => {
  const [productList, setProductList] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [isSys, setIsSys] = useState("");

  var getCurrentSystem = function () {
    if (
      document.querySelectorAll("body")[0].getAttribute("data-sys") === "win"
    ) {
      setIsSys("windows");
    } else {
      setIsSys(document.querySelectorAll("body")[0].getAttribute("data-sys"));
    }
  };

  useEffect(() => {
    getCurrentSystem();
    getProjectList();
    document.title = "开通VIP-个人中心";
    document
      .querySelector('meta[name="keywords"]')
      .setAttribute("content", "牛学长产品开通VIP");
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", "开通牛学长产品VIP");
  }, []);

  //请求牛学长站点site_id=93产品列表数据
  const getProjectList = async () => {
    setPageLoading(true);
    try {
      const { code, data } = await queryProductList(93);
      if (code === 200 && data) {
        setProductList(data);
        setPageLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //把权重 ===1 的产品往前排列
  const filterProductList = () => {
    let newList1 = [];
    let newList2 = [];
    let proList = [];
    newList1 = productList.filter((ele) => {
      return ele.weight === 1;
    });
    newList2 = productList.filter((ele) => {
      return ele.weight !== 1;
    });
    proList = newList1.concat(newList2);
    return proList;
  };

  const ProductShowFun = (props) => {
    let item = JSON.parse(JSON.stringify(props));
    return (
      <div className="cell bg-light d-flex rounded-2 position-relative">
        {item.weight === 1 && (
          <img
            src="https://images.niuxuezhang.cn/imgs/account-center/top-icon.svg"
            alt=""
            className="recommended"
          />
        )}
        <div>
          <img
            src={item.box_image}
            alt=""
            className="img-fuild flex-shrink-0"
            width={68}
            height={96}
          />
        </div>
        <div className="d-flex flex-column ms-3 ms-lg-4">
          <p className="small mb-1 fw-bold">{item.product_name}</p>
          <p className="desc tiny cell-p mb-4">{item.desc}</p>
          <a
            href={item.link}
            className={`btn btn-primary btn-sm buy-btn rounded-1 fw-normal`}
            target="_brank"
            onClick={GAClickVipBuy}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="14.466" cy="17.6049" r="1.66667" fill="white" />
              <circle cx="7.7592" cy="17.6049" r="1.66667" fill="white" />
              <path
                d="M9.68547 6.45728L15.8976 6.45728C17.0967 6.45728 18.0687 7.3956 18.0687 8.55308C18.0687 8.77504 18.0322 8.9956 17.9605 9.20649L16.5357 12.2005C16.2432 13.0611 15.4111 13.6429 14.4729 13.6429L6.06914 13.6429"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.5 1.66675L4.7072 1.66675L6.06916 13.6428"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            立即购买
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="open-vip-page">
      <div className="vip-content">
        <div className="fw-bold mb-4">开通VIP</div>
        <Spin spinning={pageLoading} tip="Loading">
          <div className="d-flex flex-wrap flex-lg-row justify-content-between h-100">
            {filterProductList() &&
              filterProductList().map((item, index) => {
                //windows电脑显示 windows产品和android产品
                if (isSys === "windows" || isSys === "android") {
                  if (item.system === "windows" || item.system === "android") {
                    return <ProductShowFun {...item} key={index} />;
                  }
                }
                //mac电脑显示 mac产品和ios产品
                if (isSys === "mac" || isSys === "ios") {
                  if (item.system === "mac" || item.system === "ios") {
                    return <ProductShowFun {...item} key={index} />;
                  }
                }
              })}
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default OpenVip;
